import { __rest, __assign } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import styles from './Grid.module.esm.js';

var Grid = function (_a) {
    var _b;
    var children = _a.children, _c = _a.component, component = _c === void 0 ? 'div' : _c, withoutContainer = _a.withoutContainer, wrapperProps = __rest(_a, ["children", "component", "withoutContainer"]);
    var El = component;
    return (React.createElement(El, __assign({}, wrapperProps, { className: classNames(wrapperProps.className, styles.marcomNavgrid, (_b = {},
            _b['nv-container'] = !withoutContainer,
            _b)) }), children));
};

export { Grid };
//# sourceMappingURL=Grid.esm.js.map
